import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import Utils from '../../../services/UtilsService';
import { CANDIDATE_ICON } from '../../../constants/IconType';
import Icon from '../IconComponent';
import useStyle from './DropdownMenuStyle';

const DropdownMenu = (props) => {
    const {
        className, menuItems, imageUrl, isMenuHidden,
    } = props;
    const { t } = useTranslation();

    const [isOpen, setOpenState] = useState(false);

    const classes = useStyle({ isOpen, isMenuEmpty: isMenuHidden || !menuItems?.length });
    const rootClasses = Utils.getClassName([
        classes.root,
        className,
    ]);

    return (
        <div className={rootClasses}>
            <div className={classes.activeArea}
                data-test-id='toggle-user-menu-btn'
                onClick={() => {
                    if (menuItems?.length) {
                        setOpenState(true);
                    }
                }}
            >
                <Icon
                    className={classes.imageIcon}
                    url={imageUrl}
                    type={CANDIDATE_ICON}
                />
                { !isMenuHidden && !!menuItems?.length && <ArrowDropDown className={classes.arrowDropDown}/> }
            </div>
            { !isMenuHidden && isOpen && !!menuItems?.length && <ClickAwayListener onClickAway={() => setOpenState(false)}>
                <Paper className={classes.paper} square data-test-id='user-menu'>
                    {(menuItems || []).map((menuItem, index) => (
                        <MenuItem
                            tabIndex={0}
                            key={index}
                            className={classes.option}
                            focus='true'
                            disabled={menuItem.disabled}
                            data-test-id={menuItem.testId || 'menu-item'}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                menuItem.onClick();
                                setOpenState(false);
                            }}
                        >
                            {t(menuItem.label)}
                        </MenuItem>
                    ))}
                </Paper>
            </ClickAwayListener> }
        </div>
    );
};

DropdownMenu.propTypes = {
    className: PropTypes.string,
    imageUrl: PropTypes.string,
    menuItems: PropTypes.array,
};

export default DropdownMenu;
